import { useNavigation } from 'expo-router';

export const usePreviousScreenName = () => {
  const navigation = useNavigation();
  const stackRoutes = navigation.getState()?.routes;
  const prevRoute = stackRoutes?.[stackRoutes.length - 2];
  return (prevRoute?.name as string) || '';
};
